import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  size?: 'default' | 'large' | 'small';
}

export default function ComicCard({ comic, size = 'default' }: ComicCardProps) {
  const coverSizes = {
    large: 'w-full aspect-[2/3]',
    default: 'w-full aspect-[2/3]',
    small: 'w-full aspect-[3/4]',
  };

  const titleSizes = {
    large: 'text-base md:text-lg',
    default: 'text-sm md:text-base',
    small: 'text-xs md:text-sm',
  };

  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block cursor-pointer"
    >
      <div className={`${coverSizes[size]} relative overflow-hidden rounded-lg mb-3`}>
        <img
          src={comic.cover}
          alt={comic.title}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <div className="absolute top-2 left-2">
          <span className={`px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
            comic.status === '连载中' ? 'bg-accent-500 text-white' : 'bg-secondary-500 text-white'
          }`}>
            {comic.status}
          </span>
        </div>
        <div className="absolute bottom-2 right-2">
          <span className="text-white/90 text-xs bg-foreground-950/60 px-2 py-0.5 rounded-full whitespace-nowrap">
            <i className="ri-star-fill text-accent-400 mr-0.5"></i>{comic.rating}
          </span>
        </div>
      </div>
      <h3 className={`${titleSizes[size]} font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1`}>
        {comic.title}
      </h3>
      <p className="text-xs text-foreground-500 mt-1 line-clamp-1">
        {comic.author} · {comic.category}
      </p>
    </Link>
  );
}